// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__c7qyO","spin":"Loader_spin__pw-GV"};